import BaseValidator from 'services/validations/base-validator';
import {getCheckedNumbers} from '../helpers';

class PlayersQuantityOfCheckedTeamsIsEnoughValidator extends BaseValidator {
    private errorMessage: string =
        'There is not enough players for the selected teams to create lineups with selected combinations. Please choose more combinations, teams or include more players for selected teams.';

    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const combos = stacking.getCheckedCombinations();
        const stacks = stacking.getStacks();

        for (const combo of Object.values(combos)) {
            for (const stackNumber of Object.keys(stacks)) {
                if (this.isStackInvalid(combo, stackNumber)) {
                    this.addError(this.errorMessage);
                    break;
                }
            }
        }
    }

    private isStackInvalid(combo, stackNumber): boolean {
        // @ts-ignore
        const {stacking, playersGroupedByTeams} = this.dependencies;
        const stackTeams = stacking.getActiveAndCheckedTeamsByStackNumber(stackNumber);

        if (!(stackNumber in combo.playersQuantity)) {
            return false;
        }

        const minPlayersQuantity = Number(combo.playersQuantity[stackNumber]);

        if (this.isThereTeamWithMinExpAndNotEnoughPlayers(stackTeams, playersGroupedByTeams, minPlayersQuantity)) {
            return true;
        }

        return !this.isThereTeamWithEnoughPlayers(stackTeams, playersGroupedByTeams, minPlayersQuantity);
    }

    private isThereTeamWithEnoughPlayers(stackTeams, playersGroupedByTeams, minPlayersQuantity): boolean {
        for (const teamName of Object.keys(stackTeams)) {
            const isTherePlayersInTeam = playersGroupedByTeams.hasOwnProperty(teamName);

            if (!isTherePlayersInTeam) {
                continue;
            }

            if (
                this.isThereEnoughPlayersInTeam(
                    stackTeams[teamName],
                    playersGroupedByTeams[teamName],
                    minPlayersQuantity,
                )
            ) {
                return true;
            }
        }

        return false;
    }

    private isThereEnoughPlayersInTeam(stackTeam, teamPlayers, minPlayersQuantity): boolean {
        const availableLineGroups = getCheckedNumbers(stackTeam.lineGroups);
        const availablePPLines = getCheckedNumbers(stackTeam.ppLines);

        if (isEmpty(availableLineGroups) && isEmpty(availablePPLines)) {
            return false;
        }

        const availablePlayers: object[] = [];
        for (const player of teamPlayers) {
            if (player.isGoalie()) {
                continue;
            }

            const isPlayerInLineGroup = inArray(Number(player.userLineGroup), availableLineGroups);
            const isPlayerInPPLine = inArray(Number(player.userPpLine), availablePPLines);

            if (isPlayerInLineGroup || isPlayerInPPLine) {
                availablePlayers.push(player);
            }
        }

        return availablePlayers.length >= minPlayersQuantity;
    }

    private isThereTeamWithMinExpAndNotEnoughPlayers(stackTeams, playersGroupedByTeams, minPlayersQuantity): boolean {
        for (const teamName of Object.keys(stackTeams)) {
            const isTeamMinExpPositive = stackTeams[teamName].exposure.min > 0;

            if (!isTeamMinExpPositive) {
                continue;
            }

            const teamPlayers = playersGroupedByTeams[teamName] ?? [];

            if (!this.isThereEnoughPlayersInTeam(stackTeams[teamName], teamPlayers, minPlayersQuantity)) {
                return true;
            }
        }

        return false;
    }
}

export default PlayersQuantityOfCheckedTeamsIsEnoughValidator;
